import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';
import { UiLibraryIconName } from '../../types/ui-library-icon-name.type';

@Component({
  selector: 'ui-library-icon',
  template: `
    @switch (name()) {
      @case ('book') {
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        </svg>
      }
      @case ('video-game') {
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M6 12h4" />
          <path d="M8 10v4" />
          <path d="M15 13h.01" />
          <path d="M18 11h.01" />
          <path d="M6 20h12a4 4 0 0 0 3.8-5.2l-1.4-5A4 4 0 0 0 16.6 7H7.4a4 4 0 0 0-3.8 2.8l-1.4 5A4 4 0 0 0 6 20z" />
        </svg>
      }
      @case ('board-game') {
        <svg viewBox="0 0 24 24" focusable="false">
          <rect x="4" y="4" width="16" height="16" rx="3" />
          <circle cx="9" cy="9" r="1" />
          <circle cx="15" cy="9" r="1" />
          <circle cx="12" cy="12" r="1" />
          <circle cx="9" cy="15" r="1" />
          <circle cx="15" cy="15" r="1" />
        </svg>
      }
      @case ('toy') {
        <svg viewBox="0 0 24 24" focusable="false">
          <rect x="4" y="4" width="7" height="7" rx="1.5" />
          <rect x="13" y="4" width="7" height="7" rx="1.5" />
          <rect x="4" y="13" width="7" height="7" rx="1.5" />
          <rect x="13" y="13" width="7" height="7" rx="1.5" />
        </svg>
      }
      @case ('electronics') {
        <svg viewBox="0 0 24 24" focusable="false">
          <rect x="6" y="3" width="12" height="18" rx="2.5" />
          <path d="M10 18h4" />
        </svg>
      }
      @case ('subscription') {
        <svg viewBox="0 0 24 24" focusable="false">
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="M3 10h18" />
          <path d="M7 15h4" />
        </svg>
      }
      @case ('console') {
        <svg viewBox="0 0 24 24" focusable="false">
          <rect x="4" y="5" width="16" height="11" rx="2" />
          <path d="M8 21h8" />
          <path d="M12 16v5" />
        </svg>
      }
      @case ('other') {
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M6 7h12l1 13H5L6 7z" />
          <path d="M9 7a3 3 0 0 1 6 0" />
        </svg>
      }
      @default {
        <span>{{ fallbackLabel() }}</span>
      }
    }
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        inline-size: 1em;
        block-size: 1em;
        line-height: 1;
      }

      svg {
        display: block;
        inline-size: 1em;
        block-size: 1em;
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.8;
      }

      span {
        font: inherit;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiLibraryIconComponent {
  public readonly name: InputSignal<UiLibraryIconName | null> = input<UiLibraryIconName | null>(null);
  public readonly fallbackLabel: InputSignal<string> = input<string>('');
}
